// src/redux/reducers/cityReducer.js
import {
    FETCH_GETORGSTYPES_FAILURE,
    FETCH_GETORGSTYPES_REQUEST,
    FETCH_GETORGSTYPES_SUCCESS, 
    SET_SELECTED_GETORGSTYPES 
  } from '../types'; 
  
  const initialState = {
    loading: false,
    orgstypesList: [],
    selectedorgstypesId: null, 
    error: null,
  };
  
  const getOrgTypesReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_GETORGSTYPES_REQUEST:
        return { ...state, loading: true };
      case FETCH_GETORGSTYPES_SUCCESS:
        return { ...state, loading: false, orgstypesList: action.payload };
      case FETCH_GETORGSTYPES_FAILURE:
        return { ...state, loading: false, error: action.payload };
      case SET_SELECTED_GETORGSTYPES:
        return { ...state, selectedorgstypesId: action.payload };
      default:
        return state;
    }
  };
  
  export default getOrgTypesReducer;
  
